import classNames from 'classnames'
import './Drawer.scss'

interface DrawerBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

export const DrawerBody: React.FC<DrawerBodyProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div className={classNames('drawer-body', className)} {...props}>
      {children}
    </div>
  )
}
